<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">ÜRÜN MARKA YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchBrand = !showSearchBrand">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Marka Arama</span>
        </h2>

        <div v-if="showSearchBrand" class="card-bg p-5">
          <form @submit.prevent="getProductBrand()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm"><b>Marka</b></label>
                <v-select @input="getProductBrand()" name="warehouse" placeholder="Seçiniz" v-model="brandSearch.brandName" :options="brandSearchList" :clearable="true" :reduce="(productBrandList) => productBrandList.brandName" label="brandName">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>

      <div class="right mb-5">
        <h2 class="mb-3 card-bg text-center hoverHeading proje_card p-6" @click="showAddBrand = !showAddBrand">
          <span class="mr-2"><feather-icon icon="EditIcon" svgClasses="h-6 w-6" /></span><span>Marka Oluştur</span>
        </h2>
        <div v-if="showAddBrand" class="card-bg p-5">
          <div class="projects tFlex gap-1 mb-3">
            <div class="left flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Marka</b></label>
                <vs-input type="text" style="width: 100%;" v-model="productBrandItem.brandName" placeholder="Marka" />
              </div>
            </div>
          </div>

          <div class="tFlex tFlex_jc-c">
            <vs-button color="success" class="width-220" @click="SaveProductBrand(productBrandItem, 'Insert', '')">Marka Ekle</vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Markalar</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="productBrandList">
            <template slot="thead">
              <vs-th>Marka</vs-th>
              <vs-th>İşlem</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.brandName">
                  <vs-td class="pt-0 pb-1">
                    <vs-input type="text" v-model="tr.brandName" style="width: 80%;" />
                  </vs-td>

                  <vs-td style="width: 10%;">
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveProductBrand(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      productBrandItem: { brandName: null },
      productBrandList: [],
      brandSearchList: [],
      brandSearch: { brandName: null },

      showAddBrand: false,
      showSearchBrand: false,
    };
  },

  computed: {},
  methods: {
    getProductBrand: async function () {
      this.$vs.loading();
      this.productBrandList = await repository.postEntity("Product/GetProductBrand", this.brandSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getSearchBrand: async function () {
      this.$vs.loading();
      this.brandSearchList = await repository.postEntity("Product/GetProductBrand", this.brandSearch).then((r) => r.list);
      this.$vs.loading.close();
    },

    SaveProductBrand: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("Product/SaveProductBrand", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.productBrandItem = {};
      this.brandSearch = {};
      this.getProductBrand();
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getProductBrand(), this.getSearchBrand()]);

    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}
</style>
